module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "National_Basketball_Association_logo.5760f7e7.svg";